/*eslint-disable*/
import React,{ useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'


const VendorVehicleDropdown = ({
        field: { name },
        form: { setFieldValue },
        vehicleData,
        vehicleId,
        ...props
    }) => {
   

    let options = []
    if (vehicleData && vehicleData.length > 0) {
        vehicleData.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleId
            temp.text = object.vehicleNumber
            temp.value = object.vehicleNumber 
            return options[index] = temp
        })
    }  

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value);
        if (vehicleId) {
            vehicleData.forEach((object, index) => {
                if (object.vehicleNumber == data.value) {
                    setFieldValue(vehicleId, object.vehicleId);
                }
            })
        }
     

    }

    return (
        <Dropdown
            search
            selection
            clearable
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            {...props}
            fluid
        />
    )
}


export default VendorVehicleDropdown